import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosInstance from "../../../services/AxiosInstance";
import Api from "../../../constants/Api";
import { successAlert } from "../alert/defaultAlert";
import UserMultiSelect from "../Custom/Identity/User/UserMultiSelect";
import HintTooltip from "../Common/HintTooltip";

const StockControlSetting = () => {

    const { t } = useTranslation();
    const [usersNotification, setUsersNotification] = useState(null);

    const save = () => {
        let usersNotificationData = [];

        if (usersNotification.length > 0) {
            usersNotification.forEach(user => {
                usersNotificationData.push({ id: user.value });
            });
        }

        let data = {
            usersNotification: usersNotificationData
        }

        axiosInstance.post(Api.parameter.stock_control, data).then(() => successAlert(t('message.data_updated_successfully'), () => { }));
    }

    useEffect(() => {
        axiosInstance.get(Api.parameter.stock_control)
            .then((resp) => {
                if (resp.data.length > 0) {
                    let usersNotificationData = [];

                    resp.data.forEach(item => {
                        if (item.usersNotification != null && item.usersNotification.length > 0) {
                            item.usersNotification.forEach(user => {
                                usersNotificationData.push({ value: user.id, label: user.fullName });
                            });
                        }
                    });

                    setUsersNotification(usersNotificationData);
                }
            });
    }, []);

    return (
        <div className="card">
            <div className="card-body">
                <h3 className="mb-2">{t('stock_management')}</h3>
                <p className="text-muted small mb-4">Gerencie o estoque de forma eficiente com configurações personalizáveis para monitoramento e reposição de produtos.</p>
                <hr className="my-4" />
                <div className="row">
                    <div className="col-xl-12 col-sm-12">
                        <div className="setting-input">
                            <label className="form-label">{t('notify_users')} <HintTooltip text={t('message.low_stock_notification_users_hint')} /></label>
                            <UserMultiSelect
                                onChange={(value) => setUsersNotification(value)}
                                value={usersNotification} />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-12">
                        <Link to={"#"} className="btn btn-primary btn-md" onClick={() => save()}>{t('save_setting')}</Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StockControlSetting;
